export default {"src":"/_next/static/image/public/magic-wand.5e935207b1d153e604b15f324719089d.svg","height":125,"width":125};